import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParams } from '../../../core/models/RouteHelper';
import MobileMatchList from './MobileMatchList';

interface OwnProps {}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(MobileMatchList);
